import  api  from "../utils/api";
import ConfirmLiveModal from "./ConfirmLiveModal";
import { useEffect, useState } from "react";


export default function PlaceOrderCard({ userId, defaultSymbol = 'AAPL' }) {
    const [symbol, setSymbol] = useState(defaultSymbol);
    const [side, setSide] = useState('buy');
    const [qty, setQty] = useState(1);
    const [type, setType] = useState('market');
    const [limitPrice, setLimitPrice] = useState('');
    const [msg, setMsg] = useState('');
    const [mode, setMode] = useState("paper");
    const [showLiveModal, setShowLiveModal] = useState(false);

    const place = async () => {
        if (mode === "live") {
            setShowLiveModal(true);
        } else {
            actuallyPlace();
        }
    };

    useEffect(() => {
        const getMode = async () => {
            try {
                const { data } = await api.get("/api/brokers/alpaca/status", { params: { user_id: userId } });
                setMode((data.mode || "paper").toLowerCase());
            } catch { }
        };
        getMode();
    }, [userId]);


    const actuallyPlace = async () => {
        try {
            const payload = {
                user_id: userId,
                symbol,
                side,
                qty: Number(qty),
                type,
                time_in_force: "day",
            };
            if (type === "limit") payload.limit_price = Number(limitPrice);
            const { data } = await api.post("/api/trade/place", payload, {
                headers: { "X-Idempotency-Key": self.crypto?.randomUUID?.() || String(Date.now()) },
            });
            setMsg(`Order ${data.order_id || data.raw?.id || "submitted"}`);
        } catch (e) {
            const err = e?.response?.data?.message || e?.response?.data?.error || e?.message || "Order failed";
            setMsg(`Order failed: ${err}`);
        }
    };

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Quick Trade</h3>
            <div className="grid grid-cols-2 gap-2">
                <input className="bg-zinc-800 rounded px-3 py-2" value={symbol} onChange={e => setSymbol(e.target.value.toUpperCase())} />
                <select className="bg-zinc-800 rounded px-3 py-2" value={side} onChange={e => setSide(e.target.value)}>
                    <option>buy</option><option>sell</option>
                </select>
                <input type="number" className="bg-zinc-800 rounded px-3 py-2" value={qty} onChange={e => setQty(e.target.value)} />
                <select className="bg-zinc-800 rounded px-3 py-2" value={type} onChange={e => setType(e.target.value)}>
                    <option>market</option><option>limit</option>
                </select>
                {type === "limit" && (
                    <input className="bg-zinc-800 rounded px-3 py-2 col-span-2" placeholder="Limit Price"
                        value={limitPrice} onChange={e => setLimitPrice(e.target.value)} />
                )}
            </div>
            <button onClick={place} className="px-4 py-2 rounded bg-blue-600">Place Order</button>
            {msg && <div className="text-sm text-zinc-300">{msg}</div>}

            <ConfirmLiveModal
                open={showLiveModal}
                onCancel={() => setShowLiveModal(false)}
                onConfirm={() => { setShowLiveModal(false); actuallyPlace(); }}
            />
        </div>
    );
}
